import React from "react";
import "./EditorCanvas.scss";

import {
  JsPlumbToolkitMiniviewComponent,
  JsPlumbToolkitSurfaceComponent,
  BrowserUIReact,
  newInstance,

} from "@jsplumbtoolkit/browser-ui-react";

import {
  Surface, SurfaceMode,
  JsPlumbToolkit,
  EVENT_EDGE_ADDED,
  EVENT_EDGE_UPDATED,
  EVENT_EDGE_REMOVED,
  EVENT_EDGE_TARGET_CHANGED,
  EVENT_EDGE_SOURCE_CHANGED,
  EVENT_UNDOREDO_UPDATE,
  EVENT_SELECTION_CLEARED,
  EVENT_NODE_UPDATED,
  EVENT_NODE_MOVE_END,
  EVENT_NODE_MOVE_START,
  EVENT_SELECT,
  EVENT_DESELECT,
  EVENT_DESTROY,
  EVENT_PORT_ADDED,
  EVENT_PORT_REMOVED,
  EVENT_PORT_UPDATED,
  EVENT_NODE_ADDED,
  EVENT_NODE_REMOVED,
  Edge,
  Node,
  ObjectData,
  EdgePathEditor,
} from "@jsplumbtoolkit/browser-ui";



import { CanvasControls } from "./Components/Controls/CanvasControls";

import {
  CanvasConfigRenderParams,
  CanvasConfigView,
} from "./Config/CanvasConfig";

import NodeModel from "../Nodes/NodeModel";
import { PlumbDataFromQuest } from "./Methods/PlumbDataFromQuest";
import ReactJson from "react-json-view";
import { QuestDataFromPlumb } from "./Methods/QuestDataFromPlumb";
import { QuestsModel } from "../../../../Models/Quests/Quests.Model";
import { EditorSidePanel } from "../SidePanel/EditorSidePanel";
import { EditorSaveButton } from "./Components/SaveButton/EditorSaveButton";
import { NavBar } from "../../../../Models/NavBar/NavBar.Model";
import { CanvasHelpers } from "./Methods/CanvasHelpers";
import BrainsDropdown from "./Components/BrainsDropdown/BrainsDropdown";
import { SwivlNavigateFunction } from "../../../../Models/NavBar/useSwivlNavigate";
import IssuesView from "./Components/Issues/IssuesView";
import { NormalQuestInterface } from "@swivl-mono/types";
import { InheritanceTag } from "../../../../Components/InheritanceTag/InheritanceTag";
import { Member } from "../../../../Models/Member/Member.Current";



// import _ from "lodash";
// OrthogonalConnectorEditor.initialize();

type CancelFunction = () => any;
type CommitFunction = (data: Record<string, any>) => any;

export type DialogManager = {
  showEdgeLabelDialog: (
    data: ObjectData,
    callback: Function,
    abort: CancelFunction
  ) => any;
  confirmDelete: (data: ObjectData, callback: CommitFunction) => any;
  editName: (data: ObjectData, callback: CommitFunction) => any;
};

interface Props {
  quest: NormalQuestInterface;
  navigate: SwivlNavigateFunction;
  canEdit: boolean;
}
interface State {
  showControls: boolean;
  isDirty: boolean;
  isSaving: boolean;
  inTestMode: boolean;
  selectedNodes: Node[];
}

export class EditorCanvas extends React.Component<Props, State> {


  toolkit: BrowserUIReact;
  view: any;
  surface?: Surface;
  surfaceComponent?: JsPlumbToolkitSurfaceComponent;
  controls: any;
  pathEditor?: EdgePathEditor;

  renderParams: any;
  loaded: boolean = false;
  constructor(props: Props) {
    super(props);



    this.state = {
      showControls: false,
      isDirty: false,
      isSaving: false,
      inTestMode: false,
      selectedNodes: [],
    };
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.setNavBar = this.setNavBar.bind(this);

    this.dataChanged = this.dataChanged.bind(this);
    this.nodeClicked = this.nodeClicked.bind(this);
    this.removeEdge = this.removeEdge.bind(this);
    this.canvasClicked = this.canvasClicked.bind(this);
    this.selectionUpdated = this.selectionUpdated.bind(this);
    this._selectionUpdated = this._selectionUpdated.bind(this);
    this.dataChanged = this.dataChanged.bind(this);
    this.portChanged = this.portChanged.bind(this);
    this.saveQuest = this.saveQuest.bind(this);
    this.loadData = this.loadData.bind(this);

    this.nodeAdded = this.nodeAdded.bind(this);
    this.updateNode = this.updateNode.bind(this);
    this.deleteNodes = this.deleteNodes.bind(this);

    this.shouldDrag = this.shouldDrag.bind(this);

    this.toolkit = newInstance()
    this.view = CanvasConfigView(this.nodeClicked, this.removeEdge);
    this.renderParams = CanvasConfigRenderParams(
      this.canvasClicked,
      this.shouldDrag
    );

    this.panToAndSelectNode = this.panToAndSelectNode.bind(this);

    this.toolkit.bind(EVENT_PORT_ADDED, this.dataChanged);
    this.toolkit.bind(EVENT_PORT_REMOVED, this.dataChanged);
    this.toolkit.bind(EVENT_PORT_UPDATED, this.dataChanged);
    this.toolkit.bind(EVENT_NODE_ADDED, this.nodeAdded);
    this.toolkit.bind(EVENT_NODE_REMOVED, this.dataChanged);
    this.toolkit.bind(EVENT_NODE_UPDATED, this.dataChanged);
    this.toolkit.bind(EVENT_EDGE_ADDED, this.portChanged);
    this.toolkit.bind(EVENT_EDGE_UPDATED, this.portChanged);
    this.toolkit.bind(EVENT_EDGE_REMOVED, this.portChanged);
    this.toolkit.bind(EVENT_EDGE_TARGET_CHANGED, this.portChanged);
    this.toolkit.bind(EVENT_EDGE_SOURCE_CHANGED, this.portChanged);
    // this.toolkit.bind(EVENT_EDGE_PATH_EDITED,this.dataChanged)
    this.toolkit.bind(EVENT_UNDOREDO_UPDATE, this.dataChanged);
    // this.toolkit.bind(EVENT_SELECTION_CLEARED,this.dataChanged)
    // this.toolkit.bind(EVENT_GRAPH_CLEAR_START,this.dataChanged)

    this.toolkit.bind(EVENT_SELECTION_CLEARED, this.selectionUpdated);
    this.toolkit.bind(EVENT_SELECT, this.selectionUpdated);
    this.toolkit.bind(EVENT_DESELECT, this.selectionUpdated);
    this.toolkit.bind(EVENT_DESTROY, this.selectionUpdated);

    // this.toolkit.bind(EVENT_NODE_MOVE_START, this.nodeMoveStartTest)
  }

  componentWillUnmount(): void {
    window.removeEventListener("keydown", this.onKeyDown);
    window.removeEventListener("keyup", this.onKeyUp);
  }
  onKeyDown(e: KeyboardEvent) {
    if (e.key === "Shift") {
      this.surface?.setMode(SurfaceMode.SELECT, true);
    }
  }
  nodeAdded(e: any) {
    if (this.loaded) {
      this.toolkit.clearSelection();
      this.toolkit.setSelection(e.node);

      var data = { ...this.toolkit.exportData() }; // JSON.parse(JSON.stringify(this.toolkit.exportData())) 



    }
  }

  onKeyUp(e: any) {
    if (e.key === "Shift") {
      this.surface?.setMode(SurfaceMode.PAN, true);
    }
  }
  dataChanged(p: any) {
    if (!this.loaded) {
      return;
    }
    // var data = this.toolkit.exportData();
    this._selectionUpdated(true);
  }
  async saveQuest() {
    this.setState({ isSaving: true, isDirty: false });


    var data = { ...this.toolkit.exportData() }; // JSON.parse(JSON.stringify(this.toolkit.exportData())) 



    let quest = this.props.quest;
    quest.data = QuestDataFromPlumb(data);



    await QuestsModel.saveQuest(quest);
    this.setState({ isSaving: false });
  }



  portChanged(p: any) {


    if (p.edge.target.id) {

      this.toolkit.updateNode(p.edge.target.id);
    }
    // this.setState({isDirty:true})
  }

  // dataGenerator (el:Element) {
  //     return NodeModel.forType(el.getAttribute("data-node-type")).Empty()
  // }

  componentDidMount() {


    this.controls.initialize(this.surface);
    this.setState({ showControls: true });
    window.addEventListener("keydown", this.onKeyDown);
    window.addEventListener("keyup", this.onKeyUp);
    setTimeout(() => {
      this.loadData();
    }, 10);
    this.setNavBar();
  }
  setNavBar() {
    const { quest, canEdit } = this.props;

    NavBar.set(
      <NavBar.Component.Back />,
      <NavBar.Component.Title
        title={quest.name}
        canEdit={canEdit}
        onSave={async (newTitle: string) => {
          quest.name = newTitle;
          await QuestsModel.updateQuest(quest, true)
          this.setNavBar()
        }}

      >
        <InheritanceTag quest={quest} />
      </NavBar.Component.Title >
      ,
      <NavBar.Component.Switch
        on={this.state.inTestMode}
        onChange={(_) => {
          this.setState({ inTestMode: !this.state.inTestMode }, () => {
            this.setNavBar();
          });
        }}
      >
        TEST MODE
      </NavBar.Component.Switch>,
      quest.name
    );
  }

  loadData() {


    const data = PlumbDataFromQuest(this.props.quest);
    this.toolkit.load({ data: data });
    this.loaded = true;

    setTimeout(() => {
      if (this.props.quest.data && this.props.quest.data['start']) {
        this.surface?.centerOn("start");
        // this.toolkit?.clearSelection()
        // this.surface?.zoomToFit()


      } else {

      }
      // _.each(this.props.quest.nodes, (n) => {
      //   if (n.type === "start") {
      //     this.surface.centerOn(n.id);
      //     

      //     return; 
      //   }})
    }, 300);

  }

  nodeClicked(node: Node, doubleClick: boolean) {
    (document.activeElement as any)?.blur()

    if (doubleClick) {
      if (node.type === "quest" && node.data.questSlug) {
        this.props.navigate(
          `/quest/${node.data.questSlug}`,
          this.props.quest.name
        );
      }
      return;
    }

    if (this.surface?.mode !== SurfaceMode.SELECT) {
      this.toolkit.clearSelection();
    }
    // this.toolkit.clearSelection()

    this.toolkit.toggleSelection(node);
  }
  removeEdge(edge: Edge) {
    this.toolkit.removeEdge(edge);
  }


  canvasClicked(e: Event) {
    (document.activeElement as any)?.blur()
    if (this.surface?.mode !== SurfaceMode.SELECT) {
      this.toolkit.clearSelection();
    }
  }

  selectionUpdated(_: any) {
    this._selectionUpdated();
  }
  _selectionUpdated(isDirty?: boolean) {
    let selectedNodes: any = [];
    this.toolkit.getSelection().eachNode((inx, node) => {
      selectedNodes.push(node);
    });
    if (isDirty) {
      this.setState({ selectedNodes: selectedNodes, isDirty: isDirty });
    } else {
      this.setState({ selectedNodes: selectedNodes });
    }
  }

  updateNode(node: Node, originalNode: Node, forceUpdate?: boolean) {
    // const edges = this.toolkit.getNode(node.id).getAllEdges();


    const newData = NodeModel.forType(node.type).PlumbData(node).node;
    this.toolkit.updateNode(node.id, newData);


    this.setState({ isDirty: true });


    setTimeout(() => {
      var data = { ...this.toolkit.exportData() }; // JSON.parse(JSON.stringify(this.toolkit.exportData())) 

    }, 1000);

    if (forceUpdate) {

      CanvasHelpers.removeNonExsistingEdges(node, this.toolkit)
    }


  }
  deleteNodes(nodeOrNodes: Node | Node[]) {
    this.setState({ selectedNodes: [], isDirty: true });
    this.toolkit.batch(() => {
      if (!(nodeOrNodes as any).id) {
        (nodeOrNodes as Node[]).forEach((node) => {
          if (CanvasHelpers.canDelete(node)) {
            this.toolkit.removeNode(node);
          }
        });
      } else {
        this.toolkit.removeNode((nodeOrNodes as Node).id);
      }
    });
    this.toolkit.clearSelection();
  }
  // updateNodeInQuest(newData: Node) {
  //   const newData = NodeModel.forType(node.type).PlumbData(node).node;
  //   this.props.quest.nodes[node.id] = newData;
  //   this.setState({ isDirty: true });
  // }

  shouldDrag(): boolean {
    return true;
  }

  panToAndSelectNode(node: Node) {
    this.toolkit.clearSelection();
    this.toolkit.setSelection(node.id);
    this.surface?.centerOn(node.id);
  }

  render() {


    const { quest, navigate, canEdit } = this.props;
    const { showControls, isDirty, isSaving, selectedNodes, inTestMode } =
      this.state;

    const selectedNode: any =
      selectedNodes.length === 1 ? this.state.selectedNodes[0] : null;


    const jsonView = quest && Member.isDev ? (
      <div className="jsonView">
        <ReactJson src={quest.data} />
      </div>
    ) : null;

    return (
      <div
        className={
          selectedNodes.length
            ? "EditorCanvas hasSelections"
            : "EditorCanvas noSelections"
        }
      >
        {jsonView}
        <div className="surfaceWrapper">
          <JsPlumbToolkitSurfaceComponent

            renderParams={this.renderParams}
            toolkit={this.toolkit}
            view={this.view}

            ref={(c: any) => {
              if (c && c.surface !== this.surface) {
                this.surfaceComponent = c;
                this.surface = c.surface;
              }
            }}
          />
        </div>
        <CanvasControls ref={(c) => (this.controls = c)} />

        {showControls && (
          <JsPlumbToolkitMiniviewComponent

            surface={this.surface!} />
        )}

        <EditorSidePanel
          toolkit={this.toolkit}
          showControls={showControls}
          surface={this.surface!}
          selectedNode={selectedNode}
          selectedNodes={selectedNodes}
          updateNode={this.updateNode}
          deleteNodes={this.deleteNodes}
          inTestMode={inTestMode}
          quest={quest}
          saveQuest={this.saveQuest}
          canEdit={canEdit}
        />
        <EditorSaveButton
          isDirty={isDirty}
          isSaving={isSaving}
          save={this.saveQuest}
          canEdit={canEdit}
        />
        <IssuesView quest={quest} panToAndSelectNode={this.panToAndSelectNode} />

        {showControls && (
          <BrainsDropdown selectedQuest={quest} navigate={navigate} canEdit={canEdit} />
        )}
      </div>
    );
  }
}
